<div style="padding: 50px">
  <app-book-form [book]="book$ | async" (save)="onSave($event)"></app-book-form>
</div>

